import React from "react";
import AgreementsReport from "../../components/agreement-report/AgreementsReport";
import "../../styles/reports-subscription/agreement.css";

const AgreementReport = () => {
  return (
    <div>
      <AgreementsReport />
    </div>
  );
};

export default AgreementReport;
